
import React, { Component } from 'react';
import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import Highcharts from 'highcharts'
import variablePie from "highcharts/modules/variable-pie.js";
variablePie(Highcharts);

class Chart2 extends Component {
	constructor(props) {
		super(props)
		this.state = {
			data: null,
			select_region_service_area: this.props.select_region_service_area
		}
	}
	componentDidMount() {
		// this.onLoadData(() => {
		// 	this.setChart(this.state.data)
		// })
	}
	onLoadData = (callback) => {
		Alert.Loading(true)
		APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1L2, {
			select_region_service_area: this.state.select_region_service_area
		}, ({ datas }) => {
			this.setState({
				data: null
			}, () => {
				this.setState({
					data: datas
				}, () => {
					Alert.LoadingClose()
					callback()
				})
			})
		})
	}
	componentWillUpdate(nextProps, nextState) {
		if (nextProps.select_region_service_area !== nextState.select_region_service_area) {
			this.setState({
				select_region_service_area: nextProps.select_region_service_area
			}, () => {
				this.onLoadData(() => {
					this.setChart(this.state.data)
				})
			})
		}
	}
	setChart(datas) {
		var categories = []
		var data_qtr = {
			qtr2: [],
			qtr3: [],
			qtr4: [],
			qtr1: [],
		}
		datas.map((row) => {
			categories.push(row.name)
			data_qtr.qtr2.push(Math.round(row.data.qtr2.nps_os))
			data_qtr.qtr3.push(Math.round(row.data.qtr3.nps_os))
			data_qtr.qtr4.push(Math.round(row.data.qtr4.nps_os))
			data_qtr.qtr1.push(Math.round(row.data.qtr1.nps_os))
		})
		var series = [{
			name: 'Quarter 2/FY21',
			data: data_qtr.qtr2
		}, {
			name: 'Quarter 3/FY21',
			data: data_qtr.qtr3
		}, {
			name: 'Quarter 4/FY21',
			data: data_qtr.qtr4
		}, {
			name: 'Quarter 1/FY21',
			data: data_qtr.qtr1
		}]

		Highcharts.chart('chart_3_1_l1', {
			title: {
				text: 'NPS-OS (%)'
			},

			subtitle: {
				text: ''
			},

			yAxis: {
				// min: 0,
				max: 100,
				title: {
					text: ''
				}
			},

			xAxis: {
				accessibility: {
					rangeDescription: ''
				},
				categories: categories
			},

			legend: {
				layout: 'vertical',
				align: 'right',
				verticalAlign: 'middle'
			},

			plotOptions: {
				series: {
					// label: {
					// 	connectorAllowed: false
					// },
					// pointStart: 2010,
					point: {
						events: {
							click: (e) => this.handleClickChart(e, categories.indexOf(e.point.category))
						}
					}
				},
				line: {
					dataLabels: {
						enabled: true
					},
					enableMouseTracking: true
				}
			},
			series: series,
			responsive: {
				rules: [{
					condition: {
						maxWidth: 500
					},
					chartOptions: {
						legend: {
							layout: 'horizontal',
							align: 'center',
							verticalAlign: 'bottom'
						}
					}
				}]
			}

		});
	}
	handleClickChart = (e, index) => {
		console.log("++++++++++++++ point : ", e)
		var quarter_number = null
		switch (e.point.series.name) {
			case "Quarter 2/FY21":
				quarter_number = 2
				break;
			case "Quarter 3/FY21":
				quarter_number = 3
				break;
			case "Quarter 4/FY21":
				quarter_number = 4
				break;
			case "Quarter 1/FY21":
				quarter_number = 1
				break;
		}
		this.props.callbackChangelevel({ level: 2, quarter_number: quarter_number, data: this.state.data[index] })
	}
	render() {
		return (
			<div className={"chart-box"}>
				<div>

				</div>
				<center>
					<div id="chart_3_1_l1" style={{ width: "92%", height: "450px" }}></div>
				</center>
			</div>
		);
	}
}

export default Chart2;